import { BaseEntityService } from '/@/modules/core/app/services/abstracts/BaseEntityService';
import { Route } from '/@/modules/core/app/constants/api.constants';
import { PlatformReferral } from '/@/modules/platformreferral/models/PlatformReferral';

export class PlatformReferralService extends BaseEntityService {
  getRoute() {
    return Route.PLATFORMREFERRALS;
  }

  getModel() {
    return PlatformReferral;
  }
}

export default new PlatformReferralService();
